module.exports = __webpack_public_path__ + "static/img/1.ff0452f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/1.png
// module id = FF/J
// module chunks = 84